module.exports = require('../dist/compat/array/last.js').last;
